export default function sortByName(options: unknown[], localizeFn: (id: any) => string) {
    return options.sort((a, b) => localizeFn(a).localeCompare(localizeFn(b)));
}
